import React from 'react';
import { ToastState, bgColor, fillColor, textColor } from './Toast';
import { Icon, Icons } from './Icon';

type Props = {
  type: ToastState;
  message: string;
  title?: string;
  icon?: Icons;
  useModern?: boolean;
};

export default function AlertNotification({
  type,
  icon,
  title,
  message,
  useModern = false
}: Props) {
  return (
    <>
      {useModern ? (
        <div className="mt-4 rounded-lg bg-slate-100 p-32">
          <div className="flex w-full flex-col items-center justify-center p-4 text-center sm:p-8">
            <Icon
              name={icon ?? Icons.Info}
              width={70}
              height={70}
              fill="#FF6606"
            />
            <h5 className="mb-2 mt-3 font-circular text-2xl font-semibold text-[#34475E]">
              {title}
            </h5>
            <p className="my-5 max-w-xl text-sm text-[#34475E] sm:text-lg">
              {message}
            </p>
          </div>
        </div>
      ) : (
        <div
          className={`m-4 flex items-center justify-center rounded border ${textColor[type]} ${bgColor[type]} p-4 text-sm`}
          role="alert"
        >
          <Icon
            name={Icons.Info}
            fill={fillColor[type]}
            height={20}
            width={20}
          />
          <div className="ml-2">
            <span className="font-medium">{message}</span>
          </div>
        </div>
      )}
    </>
  );
}
